import logo3 from "../../logo3.png";
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {useAppContext} from "../../contexts/AppContext";


export const Home = () => {
    const {years} = useAppContext();
    const [selectedYear, setSelectedYear] = useState("");

    useEffect(() => {
        if (years.length > 0) {
            setSelectedYear(String(years[years.length - 1].year));
        }
    }, [years])


    const Year = ({year}) => {

        return (
            <option value={year}>{year}</option>
        )
    }

    return (
        <>
            <div className="d-flex justify-content-center mt-5">
                {/* И1: в тъмна тема логото застава върху светла подложка —
                    надписът и буквата „R" са тъмнозелени и иначе изчезват. */}
                <div className="logoPlate" style={{maxWidth: "500px", width: "100%"}}>
                    <img style={{width: "100%", height: "auto"}} src={logo3} alt="logo"/>
                </div>
            </div>
            {/*<h2 className="d-flex justify-content-center display-3 mt-5" style={{color: "var(--app-green)"}}>ДОБРЕ ДОШЛИ</h2>*/}
            <div className="d-flex justify-content-center">
                <form className="p-3" style={{maxWidth: "420px", width: "100%"}}>
                    {/* Ж4: без надпис не е ясно какво се избира. */}
                    <label htmlFor="homeYear" className="form-label text-center d-block">
                        Избор на стопанска година
                    </label>
                    <div className="d-flex justify-content-center">
                        <select
                            id="homeYear"
                            className="form-select"
                            value={selectedYear}
                            onChange={e => setSelectedYear(e.target.value)}
                        >
                            {years.map(year => (<Year key={year.id} {...year} />))}
                        </select>
                        <Link to={`/${selectedYear}/settlements`} className="btn btn-secondary ms-2">Влез</Link>
                    </div>
                </form>
            </div>
        </>
    );
};
